const experience = [
  {
    id: "42-madrid-2024",
    title: "Programador en formación (Piscine 42 Madrid)",
    company: "Fundación Telefónica",
    start: { label: "Abr 2024", dateTime: "2024-04" },
    end: { label: "Jul 2024", dateTime: "2024-07" },
    bullets: [
      "Entorno intensivo peer-to-peer basado en proyectos, sin profesores.",
      "Desarrollo en C y shell scripting aplicando algoritmos y estructuras de datos.",
      "Enfoque en resolución de problemas, trabajo en equipo y cumplimiento de plazos ajustados.",
    ],
  },
  {
    id: "inditex-2024",
    title: "Operario de Logística",
    company: "Inditex",
    start: { label: "2024", dateTime: "2024-01" },
    end: { label: "2024", dateTime: "2024-12" },
    bullets: [
      "Preparación y gestión de pedidos en entornos de alto volumen.",
      "Coordinación en la cadena logística cumpliendo tiempos de entrega (SLAs).",
      "Control de calidad mediante checklists y optimización de procesos.",
    ],
  },
  {
    id: "sipama-2022",
    title: "Instalador de Paneles Solares",
    company: "SIPAMA",
    start: { label: "2022", dateTime: "2022-01" },
    end: { label: "2022", dateTime: "2022-12" },
    bullets: [
      "Montaje e instalación de sistemas solares en cliente final.",
      "Diagnóstico básico y resolución de incidencias in situ.",
      "Cumplimiento estricto de protocolos de seguridad y normativa vigente.",
    ],
  },
  {
    id: "plenum-2023",
    title: "Informático (Soporte Técnico)",
    company: "Plenum-Ingenieros",
    start: { label: "2023", dateTime: "2023-01" },
    end: { label: "2023", dateTime: "2023-12" },
    bullets: [
      "Soporte a usuarios de primer nivel en hardware, software y redes.",
      "Documentación de incidencias y despliegue de equipos y periféricos.",
      "Aseguramiento de la continuidad operativa con configuraciones preventivas.",
    ],
  },
];

export default experience;
